import { render, staticRenderFns } from "./Boutique.vue?vue&type=template&id=acdef18e&scoped=true&"
import script from "./Boutique.vue?vue&type=script&lang=js&"
export * from "./Boutique.vue?vue&type=script&lang=js&"
import style0 from "./Boutique.vue?vue&type=style&index=0&id=acdef18e&lang=scss&scoped=true&"
import style1 from "./Boutique.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdef18e",
  null
  
)

export default component.exports